import React, { useEffect, useState } from 'react'
import { Form, Message, Segment } from 'semantic-ui-react'

import * as styles from './styles/forms.module.css'
import ImageUpload from './controls/imageupload'

const DataRequestForm = ({
    handleFormValueChange,
    error,
    loading,
}) => {
    const [dataRequestFormValue, setDataRequestFormValue] = useState({
        name: "",
        email: "",
        contact: "",
        proofOfIdentity: undefined,
        recentOrderTransaction: "",
        requestType: [],
        requestDetails: "",
    })

    const [dataRequestFormError, setDataRequestFormError] = useState({
        name: null,
        email: null,
        contact: null,
        proofOfIdentity: null,
        recentOrderTransaction: null,
        requestType: null,
        requestDetails: null
    })

    useEffect(() => {
        if (handleFormValueChange) {
            handleFormValueChange(dataRequestFormValue);
        }
    }, [dataRequestFormValue])

    useEffect(() => {
        if (error !== undefined || error !== null) {
            setDataRequestFormError(prev => ({ ...prev, ...error }))
        }
    }, [error])

    const handleInputChange = (e, { name, value }) => {
        setDataRequestFormValue(prev => ({ ...prev, [name]: value }))

        if (value.trim().length === 0) {
            setDataRequestFormError(prev => ({ ...prev, [name]: "Required" }));
        } else {
            setDataRequestFormError(prev => ({ ...prev, [name]: null }));
        }
    }

    const handleCheckboxChange = (e, { name, value, checked }) => {
        setDataRequestFormValue(prev => {
            if (checked) {
                return { ...prev, [name]: [...prev[name], value] }
            } else {
                return { ...prev, [name]: prev[name].filter(v => v !== value) }
            }
        })

        setDataRequestFormError(prev => ({ ...prev, [name]: null }))
    }

    const handleFileInputChange = (identifier, outfname, base64data, mimetype) => {
        const newValue = base64data === ""
            ? undefined
            : { fname: outfname, mimetype, data: base64data, imgsrc: `data:${mimetype};base64,${base64data}` }

        setDataRequestFormValue(prev => ({ ...prev, [identifier]: newValue }));
        setDataRequestFormError(prev => ({ ...prev, [identifier]: null }))
    };

    return (
        <Form>
            <Form.Input
                label="Full Name*"
                placeholder="Full Name"
                value={dataRequestFormValue.name}
                name='name'
                error={dataRequestFormError.name}
                onChange={handleInputChange}
                className={`${styles.form} ${styles.formShortened}`}
                disabled={loading}
            />

            <Form.Input
                type='email'
                label="Email Address*"
                placeholder="Email Address"
                value={dataRequestFormValue.email}
                name='email'
                error={dataRequestFormError.email}
                onChange={handleInputChange}
                className={`${styles.form} ${styles.formShortened}`}
                disabled={loading}
            />

            <Form.Input
                label="Phone Number*"
                placeholder="(e.g. 0917XXXXXXX, +63917XXXXXXXX)"
                value={dataRequestFormValue.contact}
                name='contact'
                error={dataRequestFormError.contact}
                onChange={handleInputChange}
                className={`${styles.form} ${styles.formShortened}`}
                disabled={loading}
            />

            <Form.Field>
                <label>Proof of Identity</label>
                <Message error attached visible={dataRequestFormError.proofOfIdentity !== null}>
                    {dataRequestFormError.proofOfIdentity}
                </Message>
                <ImageUpload
                    identifier='proofOfIdentity'
                    outputFormat={"jpg"}
                    sizeMode={"limit"}
                    targetWidth={2048}
                    targetHeight={3840}
                    srcurl={dataRequestFormValue.proofOfIdentity?.imgsrc ?? ""}
                    shownoimage={dataRequestFormError.proofOfIdentity?.imgsrc === ""}
                    uploadHandler={handleFileInputChange}
                    disabled={loading}
                />
            </Form.Field>

            <Form.Input
                label="Recent Order # or Transaction Reference #"
                placeholder="Recent Order # or Transaction Reference #"
                value={dataRequestFormValue.recentOrderTransaction}
                name='recentOrderTransaction'
                error={dataRequestFormError.recentOrderTransaction}
                onChange={handleInputChange}
                className={`${styles.form} ${styles.formShortened}`}
                disabled={loading}
            />

            <Form.Group grouped>
                <label>Type of Request (Check all that apply)</label>
                <Message error attached visible={dataRequestFormError.requestType !== null}>
                    {dataRequestFormError.requestType}
                </Message>
                {/* Access (Right to Know) */}
                <Form.Checkbox
                    label="Retrieve my information"
                    name="requestType"
                    value="Retrieve my information"
                    onChange={handleCheckboxChange}
                    disabled={loading}
                />
                {/* Rectification (Correction) */}
                <Form.Checkbox
                    label="Correct my information"
                    name="requestType"
                    value="Correct my information"
                    onChange={handleCheckboxChange}
                    disabled={loading}
                />
                {/* Erasure (Right to be Forgotten/Blocking) */}
                <Form.Checkbox
                    label="Delete my information"
                    name="requestType"
                    value="Delete my information"
                    onChange={handleCheckboxChange}
                    disabled={loading}
                />
                {/* Portability (common structure/format) */}
                <Form.Checkbox
                    label="Transfer my information to a third party"
                    name="requestType"
                    value="Transfer my information to a third party"
                    onChange={handleCheckboxChange}
                    disabled={loading}
                />
                {/* Withdraw */}
                <Form.Checkbox
                    label="Withdraw consent to processing my information"
                    name="requestType"
                    value="Withdraw consent to processing my information"
                    onChange={handleCheckboxChange}
                    disabled={loading}
                />
                {/* Suspend/Restrict Processing */}
                <Form.Checkbox
                    label="Suspend the processing of my information"
                    name="requestType"
                    value="Suspend the processing of my information"
                    onChange={handleCheckboxChange}
                    disabled={loading}
                />
                {/* Automated Decision - Making */}
                <Form.Checkbox
                    label="Refuse decisions based solely on automated processing"
                    name="requestType"
                    value="Refuse decisions based solely on automated processing"
                    onChange={handleCheckboxChange}
                    disabled={loading}
                />
            </Form.Group>

            <Form.TextArea
                label="Request Details"
                placeholder="Request Details"
                value={dataRequestFormValue.requestDetails}
                name='requestDetails'
                error={dataRequestFormError.requestDetails}
                onChange={handleInputChange}
                className={`${styles.form} ${styles.formShortened}`}
                disabled={loading}
            />
        </Form>
    )
}

export default DataRequestForm